// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_g7-0";